<template>
  <div class="dateList">
    <page_title />
    <div class="inpBox">
      <a-input @click="goUrl('/doctorList')" ref="userNameInput" v-model="name" placeholder="请输入姓名查询">
        <a-icon slot="prefix" type="search" />
      </a-input>
    </div>

    <div class="dateItem_list">
      <div v-for="item in 4" :key="item" :class="{check :item==2}" class="date_item">
        <p class="date_item_r">周六</p>
        <p class="date_item_d">17</p>
      </div>
    </div>

    <div class="date_menu">

      <div class="data_menu_list">

        <div class="data_menu_title">分会场一</div>
        <div class="data_menu_item_box">
          <div class="data_menu_item">
            <p class="data_menu_date"><a-icon type="clock-circle" /> 13:30 - 15:30 </p>
            <p class="data_menu_name">肝脏肿瘤消融与综合治疗</p>
          </div>
          <div class="data_menu_item"></div>
          <div class="data_menu_item"></div>
          <div class="data_menu_item"></div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import page_title from './components/page_title.vue';
export default {
  components: { page_title },
  data() {
    return {
      name: ''
    }
  },
  methods: {
    goUrl(url) {
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.dateList {
  min-height: 100vw;
  background-color: #fff;
}
.inpBox {
  padding: 16px;
}
.dateItem_list {
  padding: 0 16px;
  width: 100%;
  overflow: auto;
  white-space: nowrap;
}

.date_item {
  display: inline-block;
  box-shadow: 0 1px 5px 0 rgba(0, 120, 255, 0.1);
  margin-right: 13px;
  text-align: center;
  border-radius: 5px;
  background: #f5f6fb;
  width: 60px;
  height: 60px;
  padding-top: 5px;
  p {
    margin-bottom: 0;
  }
}
.check {
  background-color: #205fae;
  color: #fff;
}
.date_item_r {
  font-size: 12px;
}
.date_item_d {
  font-size: 22px;
  font-family: -apple-system-font, Helvetica Neue, sans-serif;
  font-weight: bold;
}
.date_menu {
  overflow: hidden;
  margin-left: 16px;
  margin-top: 16px;
  border-radius: 5px 0 0 5px;
}
.data_menu_item_box {
  height: 100%;
  overflow: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.data_menu_list {
  height: 137px;
  overflow: hidden;
  margin-bottom: 2px;
}
.data_menu_list:last-child {
  margin-bottom: 0;
}

.data_menu_title {
  height: 100%;
  width: 75px;
  background: #205fae;
  float: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.data_menu_item {
  height: 100%;
  width: 150px;
  display: inline-block;
  background: #f2f5fa;
  margin-right: 2px;
  overflow: hidden;
  padding: 12px;
}
.data_menu_date {
  white-space: pre-wrap;
  font-size: 14px;
  color: black;
  margin-bottom: 0;
}
.data_menu_name {
  white-space: pre-wrap;
  font-size: 14px;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  color: black;
  margin-bottom: 0;
  text-align: justify;
}
</style>

<style>
.dateList .ant-input-affix-wrapper,
.dateList .ant-input {
  height: 36px;
  border-radius: 36px;
}
</style>
 